'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('../../core/view');

var _view2 = _interopRequireDefault(_view);

var _volume = require('./volume.scss');

var _volume2 = _interopRequireDefault(_volume);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_VOLUME_ICON_RANGE = 30;

var VolumeView = function (_View) {
  _inherits(VolumeView, _View);

  function VolumeView(config) {
    _classCallCheck(this, VolumeView);

    var _this = _possibleConstructorReturn(this, (VolumeView.__proto__ || Object.getPrototypeOf(VolumeView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['volume-control'],
      'data-hook': 'volume-control'
    });

    _this.$muteControl = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['mute-button'] + ' ' + _this.styleNames.icon,
      'data-hook': 'mute-button'
    });

    _this.$container = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.container
    });

    var $content = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.content
    });

    var $inputWrapper = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['input-wrapper']
    });

    _this.$filledProgress = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['filled-progress']
    });

    _this.$input = (0, _jbone2.default)('<input>', {
      class: '' + _this.styleNames['volume-input'],
      'data-hook': 'volume-input',
      orient: 'vertical',
      type: 'range',
      min: 0,
      max: 100,
      step: 0.1,
      value: 0
    });

    $inputWrapper.append(_this.$filledProgress).append(_this.$input);

    $content.append($inputWrapper);
    _this.$container.append($content);

    _this.$node.append(_this.$muteControl).append(_this.$container);

    _this._bindEvents();
    return _this;
  }

  _createClass(VolumeView, [{
    key: '_onInputChange',
    value: function _onInputChange() {
      this._callbacks.onVolumeLevelChangeFromInput(this.$input.val());
    }
  }, {
    key: '_onWheel',
    value: function _onWheel(e) {
      e.preventDefault();

      if (!e.deltaY) {
        return;
      }

      this._callbacks.onVolumeLevelChangeFromWheel(e.deltaY);
    }
  }, {
    key: '_preventClickPropagation',
    value: function _preventClickPropagation(event) {
      event.stopPropagation();
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._onInputChange = this._onInputChange.bind(this);
      this._onWheel = this._onWheel.bind(this);

      this.$node[0].addEventListener('wheel', this._onWheel);

      this.$container[0].addEventListener('click', this._preventClickPropagation);

      this.$input[0].addEventListener('change', this._onInputChange);

      this.$input[0].addEventListener('input', this._onInputChange);

      this.$muteControl[0].addEventListener('click', this._callbacks.onToggleMuteClick);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$node[0].removeEventListener('wheel', this._onWheel);

      this.$container[0].removeEventListener('click', this._preventClickPropagation);

      this.$input[0].removeEventListener('change', this._onInputChange);

      this.$input[0].removeEventListener('input', this._onInputChange);

      this.$muteControl[0].removeEventListener('click', this._callbacks.onToggleMuteClick);
    }
  }, {
    key: 'setState',
    value: function setState(_ref) {
      var volume = _ref.volume,
          isMuted = _ref.isMuted;

      volume !== undefined && this._setVolumeLevel(volume);
      isMuted !== undefined && this._setMuteStatus(isMuted);
    }
  }, {
    key: '_setVolumeLevel',
    value: function _setVolumeLevel(volume) {
      this.$input.val(volume);
      this.$input.attr('value', volume);
      this.$filledProgress.attr('style', 'height:' + volume + '%;');

      if (volume >= MAX_VOLUME_ICON_RANGE) {
        this.$muteControl.toggleClass(this.styleNames['half-volume'], false);
      } else {
        this.$muteControl.toggleClass(this.styleNames['half-volume'], true);
      }
    }
  }, {
    key: '_setMuteStatus',
    value: function _setMuteStatus(isMuted) {
      this.$muteControl.toggleClass(this.styleNames.muted, isMuted);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(_volume2.default.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(_volume2.default.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$input;
      delete this.$muteControl;
      delete this.$filledProgress;
      delete this.$container;
      delete this.$node;
    }
  }]);

  return VolumeView;
}(_view2.default);

VolumeView.extendStyleNames(_volume2.default);

exports.default = VolumeView;
//# sourceMappingURL=volume.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/volume/volume.view.js
// module id = 1701
// module chunks = 1 2 3